const AUTO_KEY = "alfaz_autoprint";
export const autoPrintOn = () => localStorage.getItem(AUTO_KEY) === "1";
export const setAutoPrint = (v) => localStorage.setItem(AUTO_KEY, v ? "1" : "0");

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const money = (n) => `RM${Number(n || 0).toFixed(2)}`;

function receiptHtml(o) {
  const when = new Date(o.created_at).toLocaleString("ms-MY", { timeZone: "Asia/Kuala_Lumpur", dateStyle: "medium", timeStyle: "short" });
  const lines = o.items.map((it) => `<tr><td>${esc(it.name)}${it.option ? ` (${esc(it.option)})` : ""} x${it.qty}${it.note ? `<br><i>Nota: ${esc(it.note)}</i>` : ""}</td><td class="r">${money(it.unit_price * it.qty)}</td></tr>`).join("");
  const paid = o.payment_status === "dibayar" ? "SUDAH DIBAYAR ONLINE" : "BAYAR TUNAI DI KAUNTER";
  return `<html><head><style>@page{size:80mm auto;margin:3mm}body{font-family:monospace;font-size:12px;width:72mm;margin:0}h1{font-size:15px;text-align:center;margin:0}.c{text-align:center}.r{text-align:right;white-space:nowrap;vertical-align:top}table{width:100%;border-collapse:collapse}td{padding:2px 0}hr{border:0;border-top:1px dashed #000}</style></head><body>
<img src="${window.location.origin}/img/logo.png" style="display:block;margin:0 auto 4px;width:110px;height:110px"><h1>POKYA RESTAURANT</h1><p class="c">Jalan Tengku Ahmad Panglima, Bandar Kota Bharu,<br>15400 Kota Bharu, Kelantan<br>Tel: 0148055011</p><p class="c">PESANAN APP #${esc(o.order_no)}<br>${esc(when)}</p><hr>
<p>${esc(o.customer_name)} · ${esc(o.phone)}<br>${o.mode === "pickup" ? "AMBIL DI RESTORAN" : `PENGHANTARAN: ${esc(o.address)}`}<br>Masa: ${esc(o.pickup_time)}</p><hr>
<table>${lines}</table><hr><table><tr><td><b>JUMLAH</b></td><td class="r"><b>${money(o.total)}</b></td></tr></table>
<p class="c"><b>${paid}</b>${o.loyverse_receipt ? `<br>Resit Loyverse: ${esc(o.loyverse_receipt)}` : ""}</p></body></html>`;
}

export function printReceipt(o) {
  const f = document.createElement("iframe");
  f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
  document.body.appendChild(f);
  f.contentDocument.open();
  f.contentDocument.write(receiptHtml(o));
  f.contentDocument.close();
  setTimeout(() => {
    f.contentWindow.focus();
    f.contentWindow.print();
    setTimeout(() => f.remove(), 60000);
  }, 800);
}
